import { createSlice } from "@reduxjs/toolkit";
import { PremiumInterface, ProductInterface } from "../services/QuoteServices";
import { RootState } from "../app/store";
export type IDV_RANGE = "LIDV" | "RIDV" | "HIDV";
const getTotalPremium = (quote:any, selected_addons:any) => {
  const available_addons = quote?.PREMIUM_DATA?.PREMIUM_DATA?.ADDONS?.CAN_OPT;
  let added: any[] = [];
  Object.keys(available_addons || {}).forEach((item) => {
    if (
      selected_addons.includes(item) &&
      available_addons[item] !== "NOT FOUND" &&
      available_addons[item] !== "Not Found"
    ) {
      added = [...added, { slug: item, premium: available_addons[item] }];
    }
  });
  const addOnPremium = added.reduce(
    (prev, cur) => prev + parseInt(cur.premium),
    0
  );
  return (
    parseInt(quote?.PREMIUM_DATA?.PREMIUM_DATA?.TOTAL_PREMIUM) + addOnPremium
  );
};
const initialState = {
  showEditExistingPolicyDetails: false,
  selected_plantype: "ALL",
  selectedAddons: [] as any[],
  opted:[] as any[],
  addons:[] as any[],
  quote_end_points: [] as string[],
  quotes: [] as any[],
    addons_name_slug: {},
  idv_values: {
    LIDV: Infinity,
    HIDV: -Infinity,
  } as { [key in IDV_RANGE]: number },
  selected_idv: {
    type: "" as IDV_RANGE | "Custom",
    value: 0,
  },
  see_details: {
    quoteData: {} as {
      product_data: ProductInterface;
      premium_data: PremiumInterface;
      selectedAddons: {
        name: string;
        premium: string;
      }[];
      opted: {
  slug: string;
  premium: string;
  name: string;
}[];
  totalPremiumWithAddons:number;

    },
    isOpen: false,
  },
  isPADisclaimerAccepted: false,
  addOnsWithCover: {} as Record<string, any>,
};

const quote = createSlice({
  name: "quote",
  initialState,
  reducers: {
    editExistingPolicyDetails: (state) => {
      state.showEditExistingPolicyDetails = true;
    },
    closeExistingPolicyDetailsPopup: (state) => {
      state.showEditExistingPolicyDetails = false;
    },
    setAddOns: (state, action) => {
      if (!state.selectedAddons.includes(action.payload))
        state.addons.push(action.payload);
    },
    
    updateAddons: (state, { payload }) => {
      state.addons_name_slug = payload;
    },
    removeAddons: (state, { payload }) => {
      state.selectedAddons = state.selectedAddons.filter(
        (item) => item !== payload
      );
    },
    setQuoteEndPoints: (state, action) => {
      state.quote_end_points = action.payload;
    },
    setIDVValues: (state, action) => {
      state.idv_values.HIDV = Math.max(
        action.payload.IDV_MAX,
        state.idv_values.HIDV
      );
      state.idv_values.LIDV = Math.min(
        action.payload.IDV_MIN,
        state.idv_values.LIDV
      );
      state.idv_values.RIDV = Math.floor(
        (state.idv_values.HIDV + state.idv_values.LIDV) / 2
      );
    },
    setSelectedIDV: (state, action) => {
      state.selected_idv = action.payload;
    },
    openSeeDetails: (state, action) => {
      state.see_details.quoteData = action.payload;
      state.see_details.isOpen = true;
    },
    closeSeeDetails: (state) => {
      state.see_details.isOpen = false;
    },
    setSelectedPlanType: (state, action) => {
      state.selected_plantype = action.payload;
    },

    setPADisclaimerAccepted: (state, { payload }) => {
      state.isPADisclaimerAccepted = payload;
    },
    // openIDVModal: (state) => {
    //   state.isIDVModalOpen = true;
    //   state.isPlanTypeModalOpen = false;
    // },
    // closeIDVModal: (state) => {
    //   state.isIDVModalOpen = false;
    // },
    // openPlanTypeModal: (state) => {
    //   state.isPlanTypeModalOpen = true;
    //   state.isIDVModalOpen = false;
    // },
    // closePlanTypeModal: (state) => {
    //   state.isPlanTypeModalOpen = false;
    // },
    // setQuoteEndPoints: (state, { payload }) => {
    //   state.quote_end_points = payload;
    // },
    setQuotes: (state, { payload }) => {
      state.quotes = [...state.quotes, payload].sort(
        (a, b) =>
          getTotalPremium(a, state.selectedAddons) -
          getTotalPremium(b, state.selectedAddons)
      );
    },
    sortQuotes: (state) => {
      state.quotes = state.quotes.sort(
        (a, b) =>
          getTotalPremium(a, state.selectedAddons) -
          getTotalPremium(b, state.selectedAddons)
      );
    },
    setSelectedAddons: (state, { payload }) => {
      state.selectedAddons = [...state.selectedAddons, payload];
    },
    setAddOnsWithCover: (state, { payload }) => {
      state.addOnsWithCover[payload.key] = payload.value;
    },
        removeAddon: (state, { payload }) => {
      state.selectedAddons = state.selectedAddons.filter(
        (item) => item !== payload
      );
    },
    
  },
});
export const {
  editExistingPolicyDetails,
  closeExistingPolicyDetailsPopup,
  setAddOns,
  removeAddons,
  setQuoteEndPoints,
  setIDVValues,
  setSelectedIDV,
  openSeeDetails,
  closeSeeDetails,
  setSelectedPlanType,
  setPADisclaimerAccepted,
  updateAddons,
  setQuotes,
  sortQuotes,
  setSelectedAddons,
  setAddOnsWithCover,
  removeAddon
} = quote.actions;

export const selectedAddonsSelector = (state:RootState) => state.quote.selectedAddons;
export const addOnsSlugSelector = (state: RootState) =>
  state.quote.addons_name_slug;

export default quote.reducer;
